import React from "react";
import { MdClosedCaption } from "react-icons/md";

export const CaptionFileSettings = ({ captionSettings, handleToggle, }) => {
    return (
        <div className="card shadow-sm border-0 fade-in">
            <div className="card-header text-white">
                <h5 className="card-title mb-0">
                    <span style={{ marginRight: '5px' }}> <MdClosedCaption /></span>
                    Caption Settings
                </h5>
                <small>Enable or disable captions globally for this client.</small>
            </div>

            <div className="card-body">
                <div
                    className="mb-4 p-3 border rounded-2 shadow-sm"
                    style={{ backgroundColor: "#f9f9f9" }}
                >
                    <div className="form-group custom-control custom-checkbox mb-2 d-flex align-items-center">
                        <input
                            className="custom-control-input me-2"
                            type="checkbox"
                            id="caption-status"
                            checked={captionSettings.status}
                            onChange={() => handleToggle(captionSettings.status)}
                        />
                        <label
                            className="custom-control-label fw-semibold mb-0"
                            htmlFor="caption-status"
                            style={{ fontSize: "1rem" }}
                        >
                            Enable Captions
                        </label>
                    </div>

                    <small className="text-muted mt-1 d-block">
                        If disabled, captions will stay hidden for the client across all videos.
                    </small>
                </div>
            </div>
        </div>
    );
};
